import { createFileRoute } from '@tanstack/react-router'
import { PermissionRouteGuard } from '@/hooks/usePermissions'
import { PracticesPage } from '@/pages/Practices'

export const Route = createFileRoute('/_authenticated/practices')({
  component: CustomersGuard,
})

function CustomersGuard() {
  return (
    <PermissionRouteGuard resource="customer_profiles" action="read">
      <PracticesPage />
    </PermissionRouteGuard>
  )
}
